import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { useMaximize } from '@src/mobile/hook/app';
import StatusBar from '../StatusBar';
import { Grounds } from '@ifeng-fe/client_grounds';

const Header = ({ content }) => {
    const shareHandle = () => {
        Grounds.newShare({
            shareurl: content?.voteList?.overview?.shareUrl || window.location.href,
            title: content?.voteList?.overview?.shareTitle || '',
            desc: content?.voteList?.overview?.shareDesc || '',
            thumbnail: content?.voteList?.overview?.shareImg || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            thumb: content?.voteList?.overview?.shareImg || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            documentId: 'japanvote2026',
        });
    };
    const messageHeight = useMaximize();

    const backHandle = () => {
        window.ground.close();
    };
    const isNight = window?.grounds?.getShowMode?.() === 'night';
    const isHarmony = navigator.userAgent.toLocaleLowerCase().includes('arkweb');

    return window.grounds ? (
        <div className={styles.header}>
            <div className={`${styles.headerBoxFix} ${isNight ? styles.headerBoxNight : ''}`}>
                <StatusBar statusBarHeight={messageHeight} />
                <div className={styles.headerBorder}>
                    <div className={styles.backIcon} onClick={backHandle} />
                    <div className={styles.title}>{'凤凰网'}</div>
                    {!isHarmony ? <div className={styles.rightSpace} onClick={shareHandle} /> : <div className={styles.rightSpaceHide} />}
                </div>
            </div>
            <div className={styles.headerBox}>
                <StatusBar statusBarHeight={messageHeight} />
                <div className={styles.headerBorder}>
                    <div className={styles.backIcon} onClick={backHandle} />
                    <div className={styles.title}>{'凤凰网'}</div>
                    <div className={styles.rightSpace} onClick={shareHandle} />
                </div>
            </div>
        </div>
    ) : null;
};

Header.propTypes = {
    content: PropTypes.object,
};

export default Header;
